module.exports = __webpack_public_path__ + "static/media/BAYAN ALSHAFFOUNY.e356d1d3.png";